import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import ScienceIcon from '@mui/icons-material/Science';
import ForestIcon from '@mui/icons-material/Forest';
import SpaIcon from '@mui/icons-material/Spa';
import Tooltip from '@mui/material/Tooltip';
import useColorMode from '@/hooks/useColorMode';

const ColorModeToggle = () => {
  const { mode, toggleColorMode } = useColorMode();
  const theme = useTheme();

  // Icon mapping based on themes
  const themeIcons = {
    light: <Brightness4Icon sx={{ color: 'black' }} />,
    dark: <Brightness7Icon sx={{ color: 'white' }} />,
    tokyonight: <DarkModeIcon sx={{ color: theme.palette.primary.main }} />,
    catppuccinmocha: <LocalCafeIcon sx={{ color: theme.palette.primary.main }} />, // Coffee icon for Catppuccin Mocha
    heisenberg: <ScienceIcon sx={{ color: theme.palette.primary.main }} />, // Beaker/scientific icon for Heisenberg
    colibri: <SpaIcon sx={{ color: theme.palette.primary.main }} />, // Berry-like icon for Colibri?
    everforest: <ForestIcon sx={{ color: theme.palette.primary.main }} />, // Berry-like icon for Boo Berry
  };

  // Handle switching between themes
  const handleSwitch = () => {
    toggleColorMode();
  };

  // Get the corresponding icon based on the current theme mode
  const getIcon = () => {
    return themeIcons[mode] || <Brightness4Icon />; // Fallback to light icon if mode is invalid
  };

  return (
    <Tooltip title="Toggle Theme">
      <IconButton onClick={handleSwitch} color="inherit">
        {getIcon()} {/* Get the icon dynamically based on the current theme */}
      </IconButton>
    </Tooltip>
  );
};

export default ColorModeToggle;
